// removed by extract-text-webpack-plugin
module.exports = {"headLine":"_23z1ewTBn5F_cZaOWlZ5gK","count":"_3FC8iivEe26H2NzIhAUZUL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupContacts/GroupContactsHeadLine/GroupContactsHeadLine.scss
// module id = 1269
// module chunks = 1